import { useInView } from "react-intersection-observer";

export const VantagemCard = ({infoVantagem})=>{
    const [ cardVantagemRef, cardVantagemInView ] = useInView({ triggerOnce: true, trackVisibility: true, delay: 300});

    return <>
            <div className="vantagemCard" key={infoVantagem.title.split(' ').join('')} ref={cardVantagemRef} 
            style={{transform: cardVantagemInView ? 'scale(1)' : 'scale(0)'}}>
                    <div className="logo" style={{background: `url('${require('../../assets/imgs/'+infoVantagem.image)}') no-repeat center / contain`}}/>
                    <p className="vantagemTitle">{infoVantagem.title}</p>
            </div>
        </>
}

export default VantagemCard